import { render, staticRenderFns } from "./TeamFlag.vue?vue&type=template&id=63bd8262"
import script from "./TeamFlag.vue?vue&type=script&lang=js"
export * from "./TeamFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports